export default function CompanyInfo() {
  const companyData = [
    { label: '法人名', value: '株式会社レリア' },
    { label: '代表取締役', value: '松田 晋介' },
    { label: '会社設立', value: '平成31年3月1日' },
    { label: '資本金', value: '300万円' },
    { label: '所在地', value: '〒249-0006\n神奈川県逗子市逗子5丁目11-7\nミハルアート逗子海岸202' },
    { label: '電話番号', value: '046-845-4175' },
    { label: 'FAX', value: '046-845-4176' },
    { label: 'メールアドレス', value: 'info@reria.co.jp' }
  ];

  const officeData = [
    { label: '事業所名', value: 'まごころヘルパー' },
    { label: '事業内容', value: '訪問介護ステーション' },
    { label: '介護保険事業所番号', value: '1472501285' },
    { label: '指定年月日', value: '2025年08月01日' },
    { label: '管理者', value: '松田 晋介' }
  ];

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12 max-w-5xl">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          法人概要
        </h2>

        <div className="bg-white rounded-3xl shadow-lg overflow-hidden mb-16">
          <table className="w-full">
            <tbody>
              {companyData.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 last:border-0">
                  <td className="bg-gray-50 px-8 py-6 font-bold text-gray-900 w-1/3">
                    {item.label}
                  </td>
                  <td className="px-8 py-6 text-gray-700 whitespace-pre-line">
                    {item.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          事業所情報
        </h2>

        <div className="bg-white rounded-3xl shadow-lg overflow-hidden">
          <table className="w-full">
            <tbody>
              {officeData.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 last:border-0">
                  <td className="bg-gray-50 px-8 py-6 font-bold text-gray-900 w-1/3">
                    {item.label}
                  </td>
                  <td className="px-8 py-6 text-gray-700">
                    {item.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* コンプライアンスセクション */}
        <div className="mt-24">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
            コンプライアンス・法令遵守について
          </h2>

          <div className="bg-gray-50 rounded-3xl p-10 lg:p-12 space-y-12">
            <p className="text-gray-700 leading-relaxed text-base">
              当社は、訪問介護サービスを提供する事業者として、法令および社会的規範を遵守し、利用者さま・ご家族・職員・地域社会から信頼される事業運営を行うことを重要な責務と考えています。<br />
              介護保険法、個人情報保護法、労働関係法令をはじめとする関連法令を遵守し、適正かつ誠実な事業活動に努めています。
            </p>

            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900">
                反社会的勢力との関係遮断について
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>
                  当社は、暴力団、暴力団関係企業、総会屋、その他これらに準ずる反社会的勢力との関係を一切持ちません。<br />
                  また、反社会的勢力からの不当な要求や関与があった場合には、毅然とした態度で対応し、関係機関とも連携のうえ、速やかに対応します。
                </p>
                <p>
                  取引先、関係事業者、従業員に対しても、反社会的勢力との関係を排除する姿勢を共有し、健全で透明性の高い事業環境の維持に努めます。
                </p>
              </div>
            </div>

            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900">
                個人情報・情報管理に関する姿勢
              </h3>
              <p className="text-gray-700 leading-relaxed text-base">
                当社は、利用者さまおよび職員、取引先に関する個人情報を適切に管理し、不正アクセス、漏えい、紛失等の防止に努めています。<br />
                個人情報の取り扱いについては、プライバシーポリシーに基づき、適切な管理体制のもと運用しています。
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900">
                職員への周知と体制整備
              </h3>
              <p className="text-gray-700 leading-relaxed text-base">
                法令遵守およびコンプライアンス意識の向上を目的として、職員に対する周知・教育を行い、問題が発生した場合には速やかに対応できる体制を整えています。<br />
                今後も社会的責任を果たす事業者として、継続的な体制の見直しと改善に取り組んでまいります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
